const HIGH_SCORE_KEY = 'shmerge.highScore';
const ALL_TIME_MERGES_KEY = 'shmerge.allTimeMerges';

export function getAllTimeMergeCounts(): Record<number, number> {
  try {
    const raw = localStorage.getItem(ALL_TIME_MERGES_KEY);
    if (!raw) return {};
    return JSON.parse(raw) as Record<number, number>;
  } catch { return {}; }
}

export function addToAllTimeMergeCounts(counts: Record<number, number>): void {
  const current = getAllTimeMergeCounts();
  for (const [k, v] of Object.entries(counts)) {
    const n = parseInt(k, 10);
    current[n] = (current[n] ?? 0) + v;
  }
  try { localStorage.setItem(ALL_TIME_MERGES_KEY, JSON.stringify(current)); } catch {}
}

export class ScoreState {
  current = 0;
  comboCount = 0;
  comboMultiplier = 1;
  mergeCounts: Record<number, number> = {};
  private comboTimer: ReturnType<typeof setTimeout> | null = null;
  private highScore = 0;
  onChange?: (score: number, combo: number) => void;
  onHighScore?: (hi: number) => void;

  constructor() {
    if (typeof localStorage !== 'undefined') {
      const raw = localStorage.getItem(HIGH_SCORE_KEY);
      const parsed = raw ? parseInt(raw, 10) : 0;
      this.highScore = Number.isFinite(parsed) ? parsed : 0;
    }
  }

  reset(): void {
    this.current = 0;
    this.comboCount = 0;
    this.comboMultiplier = 1;
    this.mergeCounts = {};
    if (this.comboTimer) clearTimeout(this.comboTimer);
    this.comboTimer = null;
    this.onChange?.(this.current, this.comboCount);
  }

  incrementMergeCount(tierIndex: number): void {
    this.mergeCounts[tierIndex] = (this.mergeCounts[tierIndex] ?? 0) + 1;
  }

  awardMerge(baseScore: number): { added: number; combo: number } {
    this.comboCount += 1;
    this.comboMultiplier = 1 + (this.comboCount - 1) * 0.5;
    const added = Math.round(baseScore * this.comboMultiplier);
    this.current += added;
    if (this.current > this.highScore) {
      this.highScore = this.current;
      try {
        localStorage.setItem(HIGH_SCORE_KEY, String(this.highScore));
      } catch {
        // ignore
      }
      this.onHighScore?.(this.highScore);
    }
    if (this.comboTimer) clearTimeout(this.comboTimer);
    this.comboTimer = setTimeout(() => {
      this.comboCount = 0;
      this.comboMultiplier = 1;
      this.onChange?.(this.current, this.comboCount);
    }, 700);
    this.onChange?.(this.current, this.comboCount);
    return { added, combo: this.comboCount };
  }

  awardBonus(amount: number): void {
    this.current += amount;
    if (this.current > this.highScore) {
      this.highScore = this.current;
      localStorage.setItem(HIGH_SCORE_KEY, String(this.highScore));
      this.onHighScore?.(this.highScore);
    }
    this.onChange?.(this.current, this.comboCount);
  }

  getHighScore(): number {
    return this.highScore;
  }
}
